import users from "./users";

const api = {}

const headers = {
  "X-Requested-With": "XMLHttpRequest",
  "Content-Type": "application/json",
}

function handler(data){
  return new Promise(
    (resolve, reject) => {
      return data.json().then(
        data.ok?resolve:reject
      )
    }
  )
}

function get(path, token = "") {
  return fetch(
    path,
    {
      "method": "GET",
      "headers" : {...headers, 'Authorization': 'Bearer ' + token}
    }
  ).then(handler)
}

function post(path, data, token = "") {
  return fetch(
    path,
    {
      "method"  : "POST",
      "headers" : {...headers, 'Authorization': 'Bearer ' + token},
      "body"    : JSON.stringify(data)
    }
  ).then(handler)
}

api.get  = get
api.post = post

api.users = users

export default api;